import { render, staticRenderFns } from "./StraitigraphyTab.vue?vue&type=template&id=7629f2ba&"
import script from "./StraitigraphyTab.vue?vue&type=script&lang=js&"
export * from "./StraitigraphyTab.vue?vue&type=script&lang=js&"
import style0 from "./StraitigraphyTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports